import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { User } from '../../types/User';

export interface AuthState {
  isTokenValid: boolean | null;
  userData: User | null;
}

const initialState: AuthState = {
  isTokenValid: null,
  userData: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setTokenValid: (state, action: PayloadAction<boolean>) => {
      state.isTokenValid = action.payload;
    },
    setUserData: (state, action: PayloadAction<User>) => {
      state.userData = action.payload;
    },
  },
});

export const { setTokenValid, setUserData } = authSlice.actions;
export default authSlice.reducer;
